import React from 'react';
import PeoplePicker, { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';
import MasterDataNotificationEvents from './MasterDataNotificationEvents';

const MasterDataManagersItem = ({name, managers, onSelectedUsers, events, onCheckedEvents, includeGroups = true}) => {

    return (
        <div className='settings-item'>
            <div className="settings-item-title">{name}</div>
            <PeoplePicker
                defaultUsers={managers.map(u => mapDbUserForPeoplePicker(u))}
                onSelectedUsers={onSelectedUsers} 
                includeGroups={includeGroups}
            />
            {
                onCheckedEvents &&
                <MasterDataNotificationEvents
                    notificationEvents={events}
                    onCheckedEvents={onCheckedEvents}
                />
            }
        </div>
    )

}

export default MasterDataManagersItem;


// WEBPACK FOOTER //
// ./src/components/Settings/MasterDataManagersItem.js